import React, { Component } from 'react';
import getChartLine from "./getChartLine";

class Rooms extends Component {

    componentDidMount() {
        const data = this.props.data.rooms || {};
        let dataY = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataY.push({
                    title: key,
                    data: Object.entries(data[key]).map(x => Number(x[1]) || 0)
                })
            }
        }

        const defaultData = {
            id: "Rooms",
            dataY
        };
        getChartLine(defaultData);
        window.addEventListener('resize', () => {
            getChartLine(defaultData, null, true);
        });
    }

    componentWillReceiveProps(nextProps) {
        const data = nextProps.data.rooms || {};
        let dataY = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataY.push({
                    title: key,
                    data: Object.entries(data[key]).map(x => Number(x[1]) || 0)
                })
            }
        }

        const defaultData = {
            id: "Rooms",
            dataY
        };
        getChartLine(defaultData, true);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => { });
    }

    render() {
        return (
            <div>
                <div className="total_style">Rooms</div>
                <div id="Rooms" style={{ height: 400, width: '100%' }} />
            </div>
        );
    }
}

export default Rooms;


// WEBPACK FOOTER //
// ./src/components/BI/home/Room.js